import {Badge, Text, Wrap, WrapItem} from "@chakra-ui/react";

export const columnsDataColumns = [
  {
    accessorKey: "name",
    header: "Name",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "email",
    header: "Email",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "nrp",
    header: "NRP",
    cell: (info) => info.getValue(),
  },
  {
    accessorKey: "primaryCompany",
    header: "Company Utama",
    cell: (info) => info.getValue()?.name || "-",
  },
  {
    accessorKey: "additionalCompanies",
    header: "Additional Company",
    cell: (info) => {
      const companies = info.getValue();

      if (!Array.isArray(companies) || companies.length === 0) {
        return <Text color="secondaryGray.500">-</Text>;
      }

      return (
        <Wrap spacing={2} minW="180px">
          {companies.map((company) => (
            <WrapItem key={company.id}>
              <Badge colorScheme="blue" variant="subtle" borderRadius="full" px={2} py={1} textTransform="none">
                {company.name}
              </Badge>
            </WrapItem>
          ))}
        </Wrap>
      );
    },
  },
  {
    accessorKey: "createdAt",
    header: "Created At",
    cell: (info) => new Date(info.getValue()).toLocaleString(),
  },
];
